export type MarketApprovalKeyword = {
  /** Phrase the regulator prints on its approvals. */
  keyword: string;
  /** Key in `Markets`. */
  marketName: string;
};

// From the "Market Approval Keyword" column of the approvals
// identifiers table. Searched in approval content when the approval
// quotes no uploaded certificate.
const MarketApprovalKeywords: MarketApprovalKeyword[] = [
  { keyword: 'SECRETARÍA GENERAL', marketName: 'spain' },
  {
    keyword: 'Χορήγηση Πιστοποίησης Τεχνικού Μέσου',
    marketName: 'greece',
  },
  { keyword: 'Informe Técnico', marketName: 'peru' },
  {
    keyword: 'Aprobación y Registro Componente',
    marketName: 'buenos_aires',
  },
  { keyword: 'Division of Gaming Enforcement', marketName: 'us_nj' },
  {
    keyword: 'Pennsylvania Gaming Control Board',
    marketName: 'us_pa',
  },
  { keyword: 'wvlottery', marketName: 'us_wv' },
];

export default MarketApprovalKeywords;
